// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wu3c","footer":"styles_footer__3pLGr","passCodeTooltip":"styles_passCodeTooltip__AxLiF"};